import { createStore } from 'vuex';

export const storeConfig = {
  state: () => ({
    // token: localStorage.getItem('token') || null,
    userRole: null,
    token: '',
    pin: '',
    alias: '',
    registro: '',
    nombreDocumento: '',
    indexDocFirma: '',
    indexDoc: '',
    docReferencia: '',
    docCategoria: '',
    docDocId: 0,
    actividad: '',
    impactId: '',
    fecha: null,
    x: null,
    y: null,
    pagina: null,
    user: null,
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    userRole: (state) => state.userRole,
  },
  mutations: {
    updateUserRole(state, role) {
      state.userRole = role;
    },
    updateToken(state, token) {
      state.token = token;
    },
    updatePin(state, pin) {
      state.pin = pin;
    },
    updateAlias(state, alias) {
      state.alias = alias;
    },
    updateRegistro(state, registro) {
      state.registro = registro;
    },
    updateNombreDocumento(state, nombreDocumento) {
      state.nombreDocumento = nombreDocumento;
    },
    updateIndexDocFirma(state, indexDocFirma) {
      state.indexDocFirma = indexDocFirma;
    },
    updateIndexDoc(state, indexDoc) {
      state.indexDoc = indexDoc;
    },
    updateDocReferencia(state, docReferencia) {
      state.docReferencia = docReferencia;
    },
    updateDocCategoria(state, docCategoria) {
      state.docCategoria = docCategoria;
    },
    updateDocDocId(state, docDocId) {
      state.docDocId = docDocId;
    },
    updateActividad(state, actividad) {
      state.actividad = actividad;
    },
    updateImpactId(state, impactId) {
      state.impactId = impactId;
    },
    updateImpactFecha(state, fecha) {
      state.fecha = fecha;
    },
    updateImpactX(state, x) {
      state.x = x;
    },
    updateImpactY(state, y) {
      state.y = y;
    },
    updateImpactPagina(state, pagina) {
      state.pagina = pagina;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
  },
  actions: {
    updateUserRole({ commit }, role) {
      commit('updateUserRole', role);
    },
    updateToken({ commit }, token) {
      commit('updateToken', token);
    },
    updatePin({ commit }, pin) {
      commit('updatePin', pin);
    },
    updateAlias({ commit }, alias) {
      commit('updateAlias', alias);
    },
    updateRegistro({ commit }, registro) {
      commit('updateRegistro', registro);
    },
    updateNombreDocumento({ commit }, nombreDocumento) {
      commit('updateNombreDocumento', nombreDocumento);
    },
    updateIndexDocFirma({ commit }, indexDocFirma) {
      commit('updateIndexDocFirma', indexDocFirma);
    },
    updateIndexDoc({ commit }, indexDoc) {
      commit('updateIndexDoc', indexDoc);
    },
    updateDocReferencia({ commit }, docReferencia) {
      commit('updateDocReferencia', docReferencia);
    },
    updateDocCategoria({ commit }, docCategoria) {
      commit('updateDocCategoria', docCategoria);
    },
    updateDocDocId({ commit }, docDocId) {
      commit('updateDocDocId', docDocId);
    },
    updateActividad({ commit }, actividad) {
      commit('updateActividad', actividad);
    },
    updateImpactId({ commit }, impactId) {
      commit('updateImpactId', impactId);
    },
    updateImpactFecha({ commit }, fecha) {
      commit('updateImpactFecha', fecha);
    },
    updateImpactX({ commit }, x) {
      commit('updateImpactX', x);
    },
    updateImpactY({ commit }, y) {
      commit('updateImpactY', y);
    },
    updateImpactPagina({ commit }, pagina) {
      commit('updateImpactPagina', pagina);
    },
  },
};
